import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { setDetails } from "../pre-delivery-inspection-lead-form-parent/actions";

const mapStateToProps = ({
    preDeliveryInspection: {
        cmsDetails
    },
    preDeliveryInspectionLeadData: { newCarPdiLead, isPdiLeadSelected },
    _persist: persist
}) => ({
    cmsDetails,
    newCarPdiLead,
    persist,
    isPdiLeadSelected
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setDetailsConnect: setDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
